module.exports = __webpack_public_path__ + "static/Horse-5ea615d93bf137840f5439593a98898c.jpg";